import React from 'react';

export interface SignMin7IconProps {}

export const SignMin7Icon: React.FC<SignMin7IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.79358 18.2158L6.10762 9.31735C6.13375 9.14042 6.25239 8.99091 6.41877 8.92528C6.6573 8.83118 6.92472 8.93318 7.04284 9.1539L7.06737 9.20691L8.54911 12.9638L17.3943 5.27472L19.3624 7.53885L10.5173 15.2279L14.0313 17.218C14.1675 17.2951 14.2585 17.4307 14.28 17.5833L14.2848 17.6495C14.2866 17.906 14.0951 18.1186 13.8466 18.1493L13.7884 18.153L4.79358 18.2158Z"
        fill="#192033"
      />
    </svg>
  );
};
